const filterTextoGrande = (texto, tamanhoMaximo) => {
    if (!texto) return '----'

    if (texto.length > tamanhoMaximo) {
        return texto.substring(0, tamanhoMaximo) + '...'
    }
    return texto
}

export default filterTextoGrande